import { render, staticRenderFns } from "./productModel.vue?vue&type=template&id=2bdddae8&scoped=true&"
import script from "./productModel.vue?vue&type=script&lang=js&"
export * from "./productModel.vue?vue&type=script&lang=js&"
import style0 from "./productModel.vue?vue&type=style&index=0&id=2bdddae8&prod&lang=less&scoped=true&"
import style1 from "./productModel.vue?vue&type=style&index=1&id=2bdddae8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdddae8",
  null
  
)

export default component.exports